import React, { useState, useEffect } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import { Box, Button, Image, Flex } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

const Slider = () => {
  const [ads, setAds] = useState([]);
  const [filteredAds, setFilteredAds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const url = getApiBaseUrl();

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await fetch(`${url}/ads/all/Adsall`);
        const adsData = await response.json();

        const today = new Date().toISOString();
        const validAds = adsData.filter(ad =>
          ad.status === 'Active' &&
          ad.end >= today &&
          ad.place_go === 'BigBull-World-Bottom'
        );

        setAds(adsData);
        setFilteredAds(validAds);
      } catch (error) {
        console.log('Error fetching ads:', error);
      }
    };

    fetchAds();
  }, []);

  // ⭐ AUTO SLIDE EVERY 5 SECONDS
  useEffect(() => {
    if (filteredAds.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex(prev =>
        prev === filteredAds.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [filteredAds]);

  // Manual Navigation
  const nextSlide = () => {
    setCurrentIndex(prev =>
      prev === filteredAds.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex(prev =>
      prev === 0 ? filteredAds.length - 1 : prev - 1
    );
  };

  if (filteredAds.length === 0) return null;

  const { title, banner, description } = filteredAds[currentIndex];

  return (
    <Box w="100%" textAlign="center" pb={2} pt={2} position="relative">
      <Image
        src={`${url}/${banner}`}
        alt={title}
        borderRadius="md"
        objectFit="cover"
        w="100%"
        h="90px"
      />

      {filteredAds.length > 1 && (
        <Flex
          justifyContent="space-between"
          position="absolute"
          top="50%"
          left="0"
          right="0"
          transform="translateY(-50%)"
        >
          {/* Left Button */}
          <Button
            onClick={prevSlide}
            variant="outline"
            colorScheme="brand"
            borderRadius="50%"
            width="40px"
            height="40px"
          >
            <ChevronLeftIcon boxSize={6} />
          </Button>

          {/* Right Button */}
          <Button
            onClick={nextSlide}
            variant="outline"
            colorScheme="brand"
            borderRadius="50%"
            width="40px"
            height="40px"
          >
            <ChevronRightIcon boxSize={6} />
          </Button>
        </Flex>
      )}

    </Box>
  );
};

export default Slider;
